import { render, staticRenderFns } from "./Therapy.vue?vue&type=template&id=5ff1ab40&scoped=true&"
import script from "./Therapy.vue?vue&type=script&lang=js&"
export * from "./Therapy.vue?vue&type=script&lang=js&"
import style0 from "./Therapy.vue?vue&type=style&index=0&id=5ff1ab40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1ab40",
  null
  
)

export default component.exports